export const ADMIN_EMAIL = import.meta.env.VITE_ADMIN_EMAIL || '282635@gmail.com';

export const MAX_FILE_SIZE = 64 * 1024 * 1024; // 64MB
export const SUPPORTED_VIDEO_TYPES = ['video/mp4', 'video/quicktime', 'video/webm'];